module.exports = "/assets/9e3614b981e63b0dc150b41f8ba9505c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SN.png
// module id = 1827
// module chunks = 0